import * as types from '../../index.types';

export const getAccountLedgerReport = (payload) => ({
    type: types.GET_ACCOUNT_LEDGER_REPORT,
    payload
});
